<script lang="ts">
	import { getContext } from "svelte";
	import { twMerge } from "tailwind-merge";
	import type { Readable, Writable } from "svelte/store";

	const isDesktop: Writable<boolean | undefined> = getContext("isDesktop");
	const preventScroll: Writable<boolean> = getContext("preventScroll");
	const desktopViewEnabled: Readable<boolean> = getContext("desktopViewEnabled");
</script>

<div class="@container relative flex h-dvh flex-col overflow-clip">
	<div class={twMerge("flex min-h-0 grow flex-col overflow-y-auto", $preventScroll && "overflow-y-hidden")}>
		{#if $isDesktop && !$desktopViewEnabled}
			<div class="@container mx-auto my-auto flex min-h-195.5 w-full max-w-110 shrink-0 flex-col overflow-clip rounded-3xl border border-gray-100 bg-white shadow-2xl">
				<div class="flow-vt flex grow flex-col">
					<slot />
				</div>
			</div>
		{:else}
			<div class="flow-vt flex grow flex-col">
				<slot />
			</div>
		{/if}
	</div>
</div>

<style>
	:global(html) {
		overflow: hidden;
	}

	:global(.flow-vt) {
		view-transition-name: flow-surface;
	}

	@media (prefers-reduced-motion: no-preference) {
		:global(::view-transition-old(flow-surface)),
		:global(::view-transition-new(flow-surface)) {
			animation-duration: 250ms;
			animation-timing-function: cubic-bezier(0.33, 1, 0.68, 1);
		}
	}
</style>
